import { HexColor } from 'components/shared/ColorPickerPopover/ColorPickerPopover.types';

export enum FunctionFlag {
  REQUEST_EXCLUDE = 'REQUEST_EXCLUDE',
  DUTY_OVERLAP_ALLOWED = 'DUTY_OVERLAP_ALLOWED',
  FUNCTION_GROUP = 'FUNCTION_GROUP',
  BUH_BLOCKED = 'BUH_BLOCKED',
  LEAVE_BLOCKED = 'LEAVE_BLOCKED',
  SALARY_BLOCKED = 'SALARY_BLOCKED',
  CAPPLAN_EXCLUDE = 'CAPPLAN_EXCLUDE',
  BONUS_BLOCKED = 'BONUS_BLOCKED',
  INCLUDE_IN_KIDS_RATIO = 'INCLUDE_IN_KIDS_RATIO'
}

export interface AdminFunction {
  code: string;
  valid: {
    from: string;
    to: string;
  };
  functionId?: number;
  codeExt: string;
  flags: string[];
  description: string;
  colorCode: string;
  costKind: number;
  parentFunctionDescription?: string | null;
  parentFunctionId?: number | null;
}

export type CreateEditFunctionFormProps = {
  handleClose: () => void;
  rowData?: FunctionFormValues;
};

export type FunctionFlags = {
  FUNCTION_GROUP: boolean;
  REQUEST_EXCLUDE: boolean;
  CAPPLAN_EXCLUDE: boolean;
  BUH_BLOCKED: boolean;
  BONUS_BLOCKED: boolean;
  LEAVE_BLOCKED: boolean;
  SALARY_BLOCKED: boolean;
  DUTY_OVERLAP_ALLOWED: boolean;
  INCLUDE_IN_KIDS_RATIO: boolean;
};

export interface FunctionFormValues {
  code: string;
  description: string;
  colorCode: HexColor;
  codeExt: string;
  costKind: number;
  isGroup: boolean;
  wagePerHour: number;
  flags: FunctionFlag[];
  convertedFlags: FunctionFlags;
  parentFunctionId?: number | null;
  parentFunctionDescription?: string | null;
  parentFunction?: {
    label: string;
    value: number;
  };
  functionId?: number;
  valid: {
    from: Date | null;
    to: Date | null;
  };
}
